import { Component } from '@angular/core';
import { PaymentDashboardTablesComponent } from '../payment-dashboard-tables.component';

@Component({
  selector: 'app-ar-aging-table',
  templateUrl: './ar-aging-table.component.html',
  styleUrls: ['./ar-aging-table.component.scss'],
})
export class ARAgingTableComponent extends PaymentDashboardTablesComponent {
  isShrink = true;

  changeTableSizes(shrink: boolean) {
    this.isShrink = shrink;
  }
}
